/************************* CONSTANTS *************************/
const modalQuoter = document.querySelector(".quoter-modal-overlay");
const openQuoterModalBtn = document.querySelector("#open-quoter-modal-btn");
const closeModalButton = document.querySelector(".quoter-modal-close");
const quoterForm = document.querySelector("#quoter-modal-form");

const sku = document.querySelector("span[data-product-sku]").innerText;

const sendQuoterBtn = document.querySelector("#quoter-send-btn");
const spanLoader = document.querySelector("#button-loader");
const successMessage = document.querySelector("#quoter-success");
/************************* FUNCTIONS *************************/
function toggleModal(e) {
  const modal = document.getElementById('quoter-modal');
  const body = document.body;
  const scrollY = window.scrollY;
  
  modal.style.display = 'block';
  body.classList.add('modal-open');
  body.style.top = `-${scrollY}px`;
  
  // Enfocar el primer input solo para que mejore la experiencia de usuario
  setTimeout(() => {
    const firstInput = modal.querySelector('input');
    if (firstInput) {
      firstInput.focus();
    }
  }, 100);
}

function cerrarModalQuoter() {
  const modal = document.getElementById('quoter-modal');
  const body = document.body;
  // Restaurar la posición del scroll
  const scrollY = body.style.top;
  body.style.top = '';
  body.classList.remove('modal-open');
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
  modal.style.display = 'none';
}

function windowOnClick(event) {
  if (event.target === modalQuoter) {
    toggleModal();
  }
}

async function sendQuoter(e) {
  try {
    e.preventDefault();

    sendQuoterBtn.disabled = true;
    spanLoader.style.display = "inline-block";

    const formData = new FormData(e.target);
    const quoterData = {
      sku,
    };
    formData.forEach((value, key) => {
      quoterData[key] = value;
    });

    console.log(quoterData);

    const emailResponse = await fetch(
      "https://sfc2akxvwaaxslp7iknupzh5ua0itbyj.lambda-url.us-east-1.on.aws/api/quoter",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(quoterData),
      }
    );

    const emailResult = await emailResponse.json();

    console.log(emailResult);

    sendQuoterBtn.disabled = false;
    spanLoader.style.display = "none";
    successMessage.style.display = "inline-block";
    quoterForm.reset();
  } catch (error) {
    console.log(error);
    sendQuoterBtn.disabled = true;
    spanLoader.setAttribute("style", "display: none;");
    // spanLoader.setAttribute("style", "display: none;");
  }
}

/************************* LISTENERS *************************/
if (modalQuoter && openQuoterModalBtn && closeModalButton) {
  // document.addEventListener("DOMContentLoaded", processDescription);
  openQuoterModalBtn.addEventListener("click", toggleModal);
  closeModalButton.addEventListener("click", cerrarModalQuoter);
  window.addEventListener("click", windowOnClick);
  quoterForm.addEventListener("submit", sendQuoter);
}